import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import PublicFeedbackBubble from "../components/PublicFeedbackBubble/PublicFeedbackBubble";
import routes from "./config";
import { Styles } from "../styles/styles";

const API_URL = process.env.REACT_APP_API_URL || "https://ecf.back.ejecomercial.co/api";

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      <Header />
      <Switch>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
      </Switch>
      <Footer />
      <PublicFeedbackBubble apiBase={API_URL} app="landing_corp" />
    </Suspense>
  );
};

export default Router;
